/**
 * Event subtitle
 * 
 * @module event-subtitle
 * @version 1.0.0
 * @extends HTMLElement
 */
class newEventSubtitle extends HTMLElement {

    /**
     * Event subtitle web component
     * 
     * @constructor
     */
    constructor() {

        super();

        const intersectionObserver = this.dataset.IntersectionObserver;

        if(intersectionObserver == 'true') {
            
            const handleIntersection = (entries, observer) => {

                if (!entries[0].isIntersecting) return;
    
                // init the component
                this.initSubtitle();
    
                // Stop observing the component
                observer.unobserve(this);
            }
    
            // Start observing the component
            new IntersectionObserver(handleIntersection.bind(this)).observe(this);
        }
        else {
            // init the component
            this.initSubtitle();
        }
    }

    /**
     * Init subtitle label
     * 
     * @return {undefined}
     */
    initSubtitle() {

        const handleEventName = this.dataset.eventName;

        // Check the event name
        if(handleEventName) {

            let event = window.shopEvents[handleEventName];

            if (typeof event != 'undefined') {

                this.setSubtitle(event);
            }
        }
    }

    /**
     * Set subtitle label
     * 
     * @param {Object} event Current event data.
     * @return {undefined}
     */
    setSubtitle(event) {

        const liveLabel = this.dataset.liveLabel;
        const comingSoonLabel = this.dataset.comingSoonDate;

        if(liveLabel == 'true') {

            if(event.status == 'live') {

                this.innerHTML = " ";

                if(event.start_date) {
                    let eventStartDate = new Date(event.start_date);

                    if(window.theme.shopifyDate) {

                        let shopifyCurrentDate = new Date(window.theme.shopifyDate.month + "/" + window.theme.shopifyDate.day + "/" + window.theme.shopifyDate.year);
                        let result = this.formatToDays(eventStartDate - shopifyCurrentDate);

                        if (result == 0) {
                            if (this.dataset.physicalEvent) {
                                this.innerHTML = "<span>Now Live</span>";
                            } else {
                                this.innerHTML = "<span class='event-subtitle__live-msg'>Opens Tomorrow</span><span class='event-subtitle__live-msg members'>Members shop Today</span>";
                            }
                        } else if (result <= 0) {
                            this.classList.add("now-live");
                            this.innerHTML = "Now Live";
                        } else { 
                            if(comingSoonLabel == 'true') {
                                this.innerHTML = '<span class="black">Opens ' + this.formatDateOnlyNumbers(event.start_date) + '</span>';
                            }
                            else {
                                this.innerHTML = 'Opens ' + this.formatDateOnlyNumbers(event.start_date);
                            }
                        }
                    }
                } 
        
                if(event.end_date) {

                    let eventEndDate = new Date(event.end_date);

                    if(window.theme.shopifyDate) {

                        let shopifyCurrentDate = new Date(window.theme.shopifyDate.month + "/" + window.theme.shopifyDate.day + "/" + window.theme.shopifyDate.year);
                        let result = this.formatToDays(eventEndDate - shopifyCurrentDate);

                        if(result <= 0) {
                            this.classList.add("ends-today");
                            this.innerHTML = "Ends Today";
                            this.dataset.status= "ends";
                        } else if(result <= 1) {
                            this.classList.add("now-live");
                            this.innerHTML = "Last Two Days";
                        }
                    }
                }
            }

            if (event.status == 'extended') {
                this.classList.add("ends-today");
                this.innerHTML = "Extended " + this.formatDateOnlyNumbers(event.end_date);
                this.dataset.status= "extended";
            }
        }
        
        if(event.status == 'coming-soon') {

            if(event.start_date) {
                let eventStartDate = new Date(event.start_date);
                let oneDayAfterEvent = new Date(eventStartDate);
                oneDayAfterEvent.setDate(oneDayAfterEvent.getDate() + 1);

                if(window.theme.shopifyDate) {

                    let shopifyCurrentDate = new Date(window.theme.shopifyDate.month + "/" + window.theme.shopifyDate.day + "/" + window.theme.shopifyDate.year);
                    let result = this.formatToDays(eventStartDate - shopifyCurrentDate);

                    if(result > 1 && result <= 3) {
                    let dayOfWeek = this.getDayOfWeek(eventStartDate);
                    let dayAfterWeek = this.getDayOfWeek(oneDayAfterEvent);

                    if (this.dataset.physicalEvent) {
                        this.innerHTML = '<span>Opens ' + dayOfWeek + '</span>';
                    } else {
                        this.innerHTML = `<span class="event-subtitle__opens-msg">Opens ${dayAfterWeek}</span>
                        <span class="event-subtitle__opens-msg members">
                        <svg width="100" height="100" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                                <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" style="stop-color:#5dc40c;stop-opacity:1" />
                                    <stop offset="100%" style="stop-color:#00aa9f;stop-opacity:1" />
                                </linearGradient>
                            </defs>
                            <polygon points="12,2 15,8 22,9 17,14 18,21 12,18 6,21 7,14 2,9 9,8" fill="url(#grad1)" />
                        </svg>
                        Members shop ${dayOfWeek} </span>`;
                    }

                    
                    } else {
                    if (this.dataset.physicalEvent) {
                        this.innerHTML = '<span>Opens ' + this.formatDateOnlyNumbers(event.start_date) + '</span>';
                    } else {
                        this.innerHTML = `<span class="event-subtitle__opens-msg">Opens ${this.formatDateOnlyNumbers(oneDayAfterEvent)} </span>
                        <span class="event-subtitle__opens-msg members">
                        <svg width="100" height="100" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                                <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" style="stop-color:#5dc40c;stop-opacity:1" />
                                    <stop offset="100%" style="stop-color:#00aa9f;stop-opacity:1" />
                                </linearGradient>
                            </defs>
                            <polygon points="12,2 15,8 22,9 17,14 18,21 12,18 6,21 7,14 2,9 9,8" fill="url(#grad1)" />
                        </svg>
                        Members shop ${this.formatDateOnlyNumbers(event.start_date)} </span>`;
                    }
                    }
                    
                }
            } 
        }
        
    }

    getDayOfWeek(date) {
      return Intl.DateTimeFormat(Shopify.locale, { weekday: 'long' }).format(date);
    }

    /**
     * Format event date - 02.22 (example format)
     * 
     * @param {String} eventStartDate Current event data.
     * @return {String}
     */
    formatDateOnlyNumbers(eventStartDate) {

        if(eventStartDate) {
            let date = new Date(eventStartDate);
            let month = date.getMonth() + 1;
            let day = date.getDate();

            let formattedMonth = month < 10 ? `${month}` : month;
            let formattedDay = day < 10 ? `${day}` : day;

            eventStartDate = `${formattedMonth}.${formattedDay}`;
        }

        return eventStartDate;
    }

    /**
     * Transform to days
     * 
     * @param {Number} diffDates Difference between dates.
     * @return {Number}
     */
    formatToDays(diffDates) {
        var result = 0;

        if(diffDates) {
            result = diffDates / (24 * 60 * 60 * 1000);
        }
        
        return result;
    }

    /**
     * Format event date - 22nd February (example format)
     * 
     * @param {String} eventStartDate Current event data.
     * @return {String}
     */
    formatDate(eventStartDate) {

        if(eventStartDate) {

            let dateValue = new Date(eventStartDate);
            let month = new Intl.DateTimeFormat(Shopify.locale, { month: 'long' }).format(dateValue);
            let day = new Intl.DateTimeFormat(Shopify.locale, { day: '2-digit' }).format(dateValue)

            if(day == '01' || day == '21' || day == '31') {
                day += 'st';
            }
            else if(day == '02' || day == '22') {
                day += 'nd';
            }
            else if(day == '03' || day == '23') {
                day += 'rd';
            }
            else {
                day += 'th';
            }

            eventStartDate = `${month} ${day}`;
        }

        return eventStartDate;
    }


    /**
     * Format event date - 22nd February (example format)
     * 
     * @param {String} eventStartDate Current event data.
     * @return {String}
     */
    formatDateShortMonth(eventStartDate) {

        if(eventStartDate) {

            let dateValue = new Date(eventStartDate);
            let month = new Intl.DateTimeFormat(Shopify.locale, { month: 'short' }).format(dateValue);
            let day = new Intl.DateTimeFormat(Shopify.locale, { day: '2-digit' }).format(dateValue)

            if(day == '01' || day == '21' || day == '31') {
                day += 'st';
            }
            else if(day == '02' || day == '22') {
                day += 'nd';
            }
            else if(day == '03' || day == '23') {
                day += 'rd';
            }
            else {
                day += 'th';
            }

            eventStartDate = `${month} ${day}`;
        }

        return eventStartDate;
    }
}

customElements.define('new-event-subtitle', newEventSubtitle);
